import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  return (
    <motion.a
      href="https://wa.me/971557711247"
      target="_blank"
      rel="noopener noreferrer"

      initial={{ opacity: 0, scale: 0.8, y: 40 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}

      whileHover={{ scale: 1.1, y: -4 }}
      whileTap={{ scale: 0.95 }}

      className="fixed bottom-6 right-6 z-[999]"
    >
      {/* Glow Layer */}
      <div className="absolute inset-0 rounded-full bg-green-500 blur-xl opacity-30"></div>

      {/* Button */}
      <div className="relative flex items-center justify-center w-[60px] h-[60px] rounded-full bg-gradient-to-br from-green-500 to-green-600 text-white shadow-xl border border-white/20 backdrop-blur-md">
        
        {/* Pulse Ring */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-20 animate-ping"></span>

        {/* Icon */}
        <FaWhatsapp className="text-2xl relative z-10" />
      </div>
    </motion.a>
  );
};

export default WhatsAppButton;